@if (isLoading()) {
  <app-dots-loader></app-dots-loader>
} @else {
  <app-nav-header></app-nav-header>
  @if (work()) {
    <div class="case-container">
      <div class="cover" [style.background-image]="'url(' + work()?.cover_foto?.url + ')'">
        <div class="case-header test">
          <h1>{{ work()?.title }}</h1>
        </div>
      </div>
      <div class="content">
        <h2>
          The challenge and solution
        </h2>
        <markdown [data]="work()?.description"></markdown>
      </div>
      @if (images().length > 0) {
        <div class="slide">
          <div #container class="carousel firstInit" style="width: 100%">
            <ng-image-slider
              [images]="images()"
              [infinite]="false"
              [manageImageRatio]=true
              [autoSlide]="1"
              [animationSpeed]="0.5"
              [imageSize]="{width: container.style.width, space:0, height:500}"></ng-image-slider>
          </div>
        </div>
      }
      @if (work()?.technologies) {
        <div class="techs-container">
          <h2>
            Technologies and languages
          </h2>
          <div class="techs">
            @for (item of work()?.technologies; track item.id) {
              <div class="tech-box">
                {{ item?.name }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-container">
      <div>No data</div>
    </div>
  }
  <app-footer></app-footer>
}
